import Global from "@/components/Global";
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";


export const UploadHandler = {
  MyFunction: function() {
    alert(webTypeApiUrl.MessageAPI);
  },
  Upload: function(file, messagetype) {    
    //上傳檔案
    let fd = new FormData();
    fd.append("file", file);
    fd.append("staffId", Global.current_staffid);
    let resp = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/Upload",
      type: "POST",
      cache: false,
      data: fd,
      processData: false,
      contentType: false,
      async: false
    })
      .done(function(res) {
        resp = res;
      })
      .fail(function(error) {});

    //發送訊息
    if (resp.Success) {
      $.ajax({
        url: webTypeApiUrl.MessageAPI + "/Chat/SendMediaMessage",
        type: "post",
        async: false,
        data: {
          roomId: Global.current_roomid,
          staffId: Global.current_staffid,
          filepath: resp.Result.absoluteUrl,
          previewImageUrl: resp.Result.previewImageUrl,
          messageType: messagetype,
          fileName: file.name
        },
        dataType: "json",
        success: function(data) {          
          if (!data.Success) {
            alert(data.DisplayMessage);
          }
        },
        error: function(a, b, c) {
          //window.location.href = "/#/Error";
        }
      });
    }
    return resp;
  }
};



// WEBPACK FOOTER //
// ./src/handler/UploadHandler.js